// extracted by mini-css-extract-plugin
export default {"container":"__container__+mv4M","logo":"__logo__+q1Kb","disclaimer":"__disclaimer__8vnB1","text":"__text__O+w+N","link":"__link__9GImx"};